export default __webpack_public_path__ + "static/media/about.34a8cc76.jpg";